/* SETTINGS */
export const CHANGE_LEFT_SIDEBAR = "CHANGE_LEFT_SIDEBAR"
export const SET_LAYOUT = "SET_LAYOUT"
export const SET_LOCALE = "SET_LOCALE"
export const SET_FORM_DEBUG = "SET_FORM_DEBUG"

/* LEFT MENU */
export const MENU_SET_CLASSNAMES = "MENU_SET_CLASSNAMES"
export const MENU_CONTAINER_ADD_CLASSNAME = "MENU_CONTAINER_ADD_CLASSNAME"
export const MENU_CLICK_MOBILE_MENU = "MENU_CLICK_MOBILE_MENU"
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS = "MENU_CHANGE_HAS_SUB_ITEM_STATUS"

/*TOASTER*/
export const SET_TOASTER = "SET_TOASTER"

/* FILTERS */
export const SET_FILTER_DATA = "SET_FILTER_DATA"
export const TOGGLE_FILTER = "TOGGLE_FILTER"

export const SET_INTERVAL_CHANGES = "SET_INTERVAL_CHANGES"

/* AUTH */
export const REQUEST_CURRENT_USER = "REQUEST_CURRENT_USER"
export const RECEIVE_CURRENT_USER = "RECEIVE_CURRENT_USER"
export const ERROR_CURRENT_USER = "ERROR_CURRENT_USER"

/* INFO */
export const REQUEST_INFO = "REQUEST_INFO"
export const RECEIVE_INFO = "RECEIVE_INFO"
export const ERROR_INFO = "ERROR_INFO"

/* INFO-LOGIN */
export const REQUEST_INFO_LOGIN = "REQUEST_INFO_LOGIN"
export const RECEIVE_INFO_LOGIN = "RECEIVE_INFO_LOGIN"
export const ERROR_INFO_LOGIN = "ERROR_INFO_LOGIN"

/* STRINGS */
export const REQUEST_STRINGS = "REQUEST_STRINGS"
export const RECEIVE_STRINGS = "RECEIVE_STRINGS"
export const UPDATE_STRINGS = "UPDATE_STRINGS"
export const ERROR_STRINGS = "ERROR_STRINGS"
export const TOGGLE_DEV_STRINGS = "TOGGLE_DEV_STRINGS"

/*ADMIN STRINGS*/
export const REQUEST_ADMIN_STRINGS = "REQUEST_ADMIN_STRINGS"
export const RECEIVE_ADMIN_STRINGS = "RECEIVE_ADMIN_STRINGS"
export const UPDATE_ADMIN_STRINGS = "UPDATE_ADMIN_STRINGS"
export const ERROR_ADMIN_STRINGS = "ERROR_ADMIN_STRINGS"

/* DATA_STRUCTURES */
export const REQUEST_DATA_STRUCTURE = "REQUEST_DATA_STRUCTURE"
export const RECEIVE_DATA_STRUCTURE = "RECEIVE_DATA_STRUCTURE"
export const ERROR_DATA_STRUCTURE = "ERROR_DATA_STRUCTURE"

/* ENUMS */
export const REQUEST_ENUMS = "REQUEST_ENUMS"
export const RECEIVE_ENUMS = "RECEIVE_ENUMS"
export const RELOAD_ENUMS = "RELOAD_ENUMS"
export const ERROR_ENUMS = "ERROR_ENUMS"

/* FAQS */
export const REQUEST_FAQ = "REQUEST_FAQ"
export const RECEIVE_FAQ = "RECEIVE_FAQ"
export const ERROR_FAQ = "ERROR_FAQ"

/* USERS */
export const REQUEST_USERS = "REQUEST_USERS"
export const RECEIVE_USERS = "RECEIVE_USERS"
export const UPDATE_USERS = "UPDATE_USERS"
export const ERROR_USERS = "ERROR_USERS"

/* CALCULATIONS */
export const REQUEST_CALCULATIONS = "REQUEST_CALCULATIONS"
export const RECEIVE_CALCULATIONS = "RECEIVE_CALCULATIONS"
export const UPDATE_CALCULATIONS = "UPDATE_CALCULATIONS"
export const ERROR_CALCULATIONS = "ERROR_CALCULATIONS"

/* CALCULATION */
export const REQUEST_CALCULATION = "REQUEST_CALCULATION"
export const RECEIVE_CALCULATION = "RECEIVE_CALCULATION"
export const UPDATE_CALCULATION = "UPDATE_CALCULATION"
export const RELOAD_CALCULATION = "RELOAD_CALCULATION"
export const ERROR_CALCULATION = "ERROR_CALCULATION"
export const MODIFY_CALCULATION = "MODIFY_CALCULATION"
export const UPDATE_CALCULATION_AVAILABLE_COMPANY = "UPDATE_CALCULATION_AVAILABLE_COMPANY"
export const UPDATE_CALCULATION_RESULT = "UPDATE_CALCULATION_RESULT"
export const MODIFY_CALCULATION_RESULT = "MODIFY_CALCULATION_RESULT"

/* ITEM */
export const REQUEST_ITEM = "REQUEST_ITEM"
export const RECEIVE_ITEM = "RECEIVE_ITEM"
export const UPDATE_ITEM = "UPDATE_ITEM"
export const RELOAD_ITEM = "RELOAD_ITEM"
export const ERROR_ITEM = "ERROR_ITEM"

/* LAZY_OPTIONS */
export const REQUEST_LAZY_LOAD = "REQUEST_LAZY_LOAD"
export const RECEIVE_LAZY_LOAD = "RECEIVE_LAZY_LOAD"
export const ERROR_LAZY_LOAD = "ERROR_LAZY_LOAD"
/* SETTINGS_COMPANIES */
export const REQUEST_SETTINGS_COMPANIES = "REQUEST_SETTINGS_COMPANIES"
export const RECEIVE_SETTINGS_COMPANIES = "RECEIVE_SETTINGS_COMPANIES"
export const UPDATE_SETTINGS_COMPANIES = "UPDATE_SETTINGS_COMPANIES"
export const ERROR_SETTINGS_COMPANIES = "ERROR_SETTINGS_COMPANIES"
/* SETTINGS_EMAILS */
export const REQUEST_SETTINGS_EMAILS = "REQUEST_SETTINGS_EMAILS"
export const RECEIVE_SETTINGS_EMAILS = "RECEIVE_SETTINGS_EMAILS"
export const UPDATE_SETTINGS_EMAILS = "UPDATE_SETTINGS_EMAILS"
export const ERROR_SETTINGS_EMAILS = "ERROR_SETTINGS_EMAILS"
/* SETTINGS_CREDENTIALS */
export const REQUEST_SETTINGS_CREDENTIALS = "REQUEST_SETTINGS_CREDENTIALS"
export const RECEIVE_SETTINGS_CREDENTIALS = "RECEIVE_SETTINGS_CREDENTIALS"
export const UPDATE_SETTINGS_CREDENTIALS = "UPDATE_SETTINGS_CREDENTIALS"
export const ERROR_SETTINGS_CREDENTIALS = "ERROR_SETTINGS_CREDENTIALS"
/* SETTINGS_ZZJS */
export const REQUEST_SETTINGS_ZZJS = "REQUEST_SETTINGS_ZZJS"
export const RECEIVE_SETTINGS_ZZJS = "RECEIVE_SETTINGS_ZZJS"
export const UPDATE_SETTINGS_ZZJS = "UPDATE_SETTINGS_ZZJS"
export const ERROR_SETTINGS_ZZJS = "ERROR_SETTINGS_ZZJS"
/* USERS_ROLES */
export const REQUEST_USERS_ROLES = "REQUEST_USERS_ROLES"
export const RECEIVE_USERS_ROLES = "RECEIVE_USERS_ROLES"
export const UPDATE_USERS_ROLES = "UPDATE_USERS_ROLES"
export const ERROR_USERS_ROLES = "ERROR_USERS_ROLES"

/* HELP */
export const REQUEST_HINT = "REQUEST_HINT"
export const RECEIVE_HINT = "RECEIVE_HINT"
export const ERROR_HINT = "ERROR_HINT"
/* USER_UCREDENTIALS */
export const REQUEST_USER_UCREDENTIALS = "REQUEST_USER_UCREDENTIALS"
export const RECEIVE_USER_UCREDENTIALS = "RECEIVE_USER_UCREDENTIALS"
export const UPDATE_USER_UCREDENTIALS = "UPDATE_USER_UCREDENTIALS"
export const ERROR_USER_UCREDENTIALS = "ERROR_USER_UCREDENTIALS"
/* SETTINGS_PRODUCTS */
export const REQUEST_SETTINGS_PRODUCTS = "REQUEST_SETTINGS_PRODUCTS"
export const RECEIVE_SETTINGS_PRODUCTS = "RECEIVE_SETTINGS_PRODUCTS"
export const UPDATE_SETTINGS_PRODUCTS = "UPDATE_SETTINGS_PRODUCTS"
export const ERROR_SETTINGS_PRODUCTS = "ERROR_SETTINGS_PRODUCTS"
/* SETTINGS_PRODUCTCESTS */
export const REQUEST_SETTINGS_PRODUCTCESTS = "REQUEST_SETTINGS_PRODUCTCESTS"
export const RECEIVE_SETTINGS_PRODUCTCESTS = "RECEIVE_SETTINGS_PRODUCTCESTS"
export const UPDATE_SETTINGS_PRODUCTCESTS = "UPDATE_SETTINGS_PRODUCTCESTS"
export const ERROR_SETTINGS_PRODUCTCESTS = "ERROR_SETTINGS_PRODUCTCESTS"
/* SETTINGS_PRODUCTMAJS */
export const REQUEST_SETTINGS_PRODUCTMAJS = "REQUEST_SETTINGS_PRODUCTMAJS"
export const RECEIVE_SETTINGS_PRODUCTMAJS = "RECEIVE_SETTINGS_PRODUCTMAJS"
export const UPDATE_SETTINGS_PRODUCTMAJS = "UPDATE_SETTINGS_PRODUCTMAJS"
export const ERROR_SETTINGS_PRODUCTMAJS = "ERROR_SETTINGS_PRODUCTMAJS"
/* SETTINGS_PRODUCTODPS */
export const REQUEST_SETTINGS_PRODUCTODPS = "REQUEST_SETTINGS_PRODUCTODPS"
export const RECEIVE_SETTINGS_PRODUCTODPS = "RECEIVE_SETTINGS_PRODUCTODPS"
export const UPDATE_SETTINGS_PRODUCTODPS = "UPDATE_SETTINGS_PRODUCTODPS"
export const ERROR_SETTINGS_PRODUCTODPS = "ERROR_SETTINGS_PRODUCTODPS"
/* SETTINGS_PREDEFCOMBS */
export const REQUEST_SETTINGS_PREDEFCOMBS = "REQUEST_SETTINGS_PREDEFCOMBS"
export const RECEIVE_SETTINGS_PREDEFCOMBS = "RECEIVE_SETTINGS_PREDEFCOMBS"
export const UPDATE_SETTINGS_PREDEFCOMBS = "UPDATE_SETTINGS_PREDEFCOMBS"
export const ERROR_SETTINGS_PREDEFCOMBS = "ERROR_SETTINGS_PREDEFCOMBS"
/* SETTINGS_ENUMS */
export const REQUEST_SETTINGS_ENUMS = "REQUEST_SETTINGS_ENUMS"
export const RECEIVE_SETTINGS_ENUMS = "RECEIVE_SETTINGS_ENUMS"
export const UPDATE_SETTINGS_ENUMS = "UPDATE_SETTINGS_ENUMS"
export const ERROR_SETTINGS_ENUMS = "ERROR_SETTINGS_ENUMS"
/* SETTINGS_EXTCCARS */
export const REQUEST_SETTINGS_EXTCCARS = "REQUEST_SETTINGS_EXTCCARS"
export const RECEIVE_SETTINGS_EXTCCARS = "RECEIVE_SETTINGS_EXTCCARS"
export const UPDATE_SETTINGS_EXTCCARS = "UPDATE_SETTINGS_EXTCCARS"
export const ERROR_SETTINGS_EXTCCARS = "ERROR_SETTINGS_EXTCCARS"
/* SETTINGS_EXTCALCMAJS */
export const REQUEST_SETTINGS_EXTCALCMAJS = "REQUEST_SETTINGS_EXTCALCMAJS"
export const RECEIVE_SETTINGS_EXTCALCMAJS = "RECEIVE_SETTINGS_EXTCALCMAJS"
export const UPDATE_SETTINGS_EXTCALCMAJS = "UPDATE_SETTINGS_EXTCALCMAJS"
export const ERROR_SETTINGS_EXTCALCMAJS = "ERROR_SETTINGS_EXTCALCMAJS"
/* SETTINGS_ADDINFOS */
export const REQUEST_SETTINGS_ADDINFOS = "REQUEST_SETTINGS_ADDINFOS"
export const RECEIVE_SETTINGS_ADDINFOS = "RECEIVE_SETTINGS_ADDINFOS"
export const UPDATE_SETTINGS_ADDINFOS = "UPDATE_SETTINGS_ADDINFOS"
export const ERROR_SETTINGS_ADDINFOS = "ERROR_SETTINGS_ADDINFOS"
/* SETTINGS_CARMODELS */
export const REQUEST_SETTINGS_CARMODELS = "REQUEST_SETTINGS_CARMODELS"
export const RECEIVE_SETTINGS_CARMODELS = "RECEIVE_SETTINGS_CARMODELS"
export const UPDATE_SETTINGS_CARMODELS = "UPDATE_SETTINGS_CARMODELS"
export const ERROR_SETTINGS_CARMODELS = "ERROR_SETTINGS_CARMODELS"
/* SETTINGS_CARMODELOSTS */
export const REQUEST_SETTINGS_CARMODELOSTS = "REQUEST_SETTINGS_CARMODELOSTS"
export const RECEIVE_SETTINGS_CARMODELOSTS = "RECEIVE_SETTINGS_CARMODELOSTS"
export const UPDATE_SETTINGS_CARMODELOSTS = "UPDATE_SETTINGS_CARMODELOSTS"
export const ERROR_SETTINGS_CARMODELOSTS = "ERROR_SETTINGS_CARMODELOSTS"
/* CONTRACTS */
export const REQUEST_CONTRACTS = "REQUEST_CONTRACTS"
export const RECEIVE_CONTRACTS = "RECEIVE_CONTRACTS"
export const FAILED_CONTRACTS = "FAILED_CONTRACTS"
/* SETTINGS_MENUFILES */
export const REQUEST_SETTINGS_MENUFILES = "REQUEST_SETTINGS_MENUFILES"
export const RECEIVE_SETTINGS_MENUFILES = "RECEIVE_SETTINGS_MENUFILES"
export const UPDATE_SETTINGS_MENUFILES = "UPDATE_SETTINGS_MENUFILES"
export const ERROR_SETTINGS_MENUFILES = "ERROR_SETTINGS_MENUFILES"
/* SETTINGS_GLOBALMENUFILES */
export const REQUEST_SETTINGS_GLOBALMENUFILES = "REQUEST_SETTINGS_GLOBALMENUFILES"
export const RECEIVE_SETTINGS_GLOBALMENUFILES = "RECEIVE_SETTINGS_GLOBALMENUFILES"
export const UPDATE_SETTINGS_GLOBALMENUFILES = "UPDATE_SETTINGS_GLOBALMENUFILES"
export const ERROR_SETTINGS_GLOBALMENUFILES = "ERROR_SETTINGS_GLOBALMENUFILES"
/*modules_here*/